import { render, staticRenderFns } from "./PersonsCount.vue?vue&type=template&id=21fb0fbd&"
import script from "./PersonsCount.vue?vue&type=script&lang=js&"
export * from "./PersonsCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports